var _rect, _rect2, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgScratchOff = function SvgScratchOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 71,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.828,
    y: 2,
    width: 46.344,
    height: 67,
    rx: 2.5,
    stroke: "#577687",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.578,
    y: 30.75,
    width: 29.5,
    height: 28.25,
    rx: 2.5,
    stroke: "#577687",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.951,
    cy: 16.975,
    r: 6.533,
    stroke: "#577687",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.195,
    cy: 16.975,
    r: 6.533,
    stroke: "#577687",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.573,
    cy: 14.68,
    r: 7.68,
    fill: "#30424D",
    stroke: "#577687",
    strokeWidth: 3
  })));
};

export default SvgScratchOff;